import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'simple-database.field-1-name': {
    id: 'simple-database.field-1-name',
    defaultMessage: 'Item',
    description:
      'The field name (and the default value/watermark) in field #1 for this database template. In this case: Item',
  },
  'simple-database.field-1-description': {
    id: 'simple-database.field-1-description',
    defaultMessage: 'Give each item a unique name',
    description:
      'The field description for field #1 in this database template. In this case: Give each item a unique name',
  },
  'simple-database.field-1-default-value': {
    id: 'simple-database.field-1-default-value',
    defaultMessage: 'Add an item here',
    description:
      'The default value for field #1 in this database template. In this case: Add an item here',
  },
  'simple-database.field-2-name': {
    id: 'simple-database.field-2-name',
    defaultMessage: 'Tag',
    description:
      'The field name (and the default value/watermark) in field #2 for this database template. In this case: Tag',
  },
  'simple-database.field-2-description': {
    id: 'simple-database.field-2-description',
    defaultMessage: 'Use labeling to provide extra context',
    description:
      'The field description for field #2 in this database template. In this case: Use labeling to provide extra context',
  },
  'simple-database.field-2-select-option-1': {
    id: 'simple-database.field-2-select-option-1',
    defaultMessage: 'Tag A',
    description:
      'The option value for option #1 in field #2 for this database template. In this case: Tag A',
  },
  'simple-database.field-2-select-option-2': {
    id: 'simple-database.field-2-select-option-2',
    defaultMessage: 'Tag B',
    description:
      'The option value for option #2 in field #2 for this database template. In this case: Tag B',
  },
  'simple-database.field-2-select-option-3': {
    id: 'simple-database.field-2-select-option-3',
    defaultMessage: 'Tag C',
    description:
      'The option value for option #3 in field #2 for this database template. In this case: Tag C',
  },
  'simple-database.field-3-name': {
    id: 'simple-database.field-3-name',
    defaultMessage: 'Description',
    description:
      'The field name (and the default value/watermark) in field #3 for this database template. In this case: Description',
  },
  'simple-database.field-3-description': {
    id: 'simple-database.field-3-description',
    defaultMessage: 'Use this field to clarify and inform',
    description:
      'The field description for field #3 in this database template. In this case: Use this field to clarify and inform',
  },
  'simple-database.field-3-default-value': {
    id: 'simple-database.field-3-default-value',
    defaultMessage: 'Add some extra details here',
    description:
      'The default value for field #3 in this database template. In this case: Add some extra details here',
  },
  'simple-database.field-4-name': {
    id: 'simple-database.field-4-name',
    defaultMessage: 'Teammates',
    description:
      'The field name (and the default value/watermark) in field #4 for this database template. In this case: Teammates',
  },
  'simple-database.field-4-description': {
    id: 'simple-database.field-4-description',
    defaultMessage: 'Add teammates to start collaborating',
    description:
      'The field description for field #4 in this database template. In this case: Add teammates to start collaborating',
  },
  'simple-database.view-1-name': {
    id: 'simple-database.view-1-name',
    defaultMessage: 'Table',
    description:
      'The view name for view #1 in this template. Displayed on the top left of the screen (below the database name). In this case: Table',
  },
  'simple-database.view-2-name': {
    id: 'simple-database.view-2-name',
    defaultMessage: 'Gallery',
    description:
      'The view name for view #2 in this template. Displayed on the top left of the screen (below the database name). In this case: Gallery',
  },
  'simple-database.view-3-name': {
    id: 'simple-database.view-3-name',
    defaultMessage: 'Board',
    description:
      'The view name for view #3 in this template. Displayed on the top left of the screen (below the database name). In this case: Board',
  },
});
